import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/")({
  head: () => buildRouteHead("/en/services/one-vigilance/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/services/pharmacovigilance", replace: true });
  },
});
